// extracted by mini-css-extract-plugin
module.exports = {"head":"ageMenu_head__y9yvt","body":"ageMenu_body__31gAR","ageButton":"ageMenu_ageButton__230wT","buttonGroup":"ageMenu_buttonGroup__1xzvx"};